export default __webpack_public_path__ + "static/md5-15359c3053eb256824ec82daab6eac6c.png";